import * as React from 'react'
import styled from 'styled-components'
import { Button, ButtonSecondary, ButtonSecondarySmall, ButtonSmall } from '../atoms/Button'
import { Checkbox } from '../atoms/Checkbox/index'
import { Input } from '../atoms/Input'
import { Label } from '../atoms/Label'
import { Link } from '../atoms/Link'
import { LinkButton } from '../atoms/LinkButton'
import { RadioButton } from '../atoms/RadioButton'
import { Scale } from '../atoms/Scale'
import { Select } from '../atoms/Select'
import { WithLabel } from '../molecules/WithLabel'

const Row = styled.div`
  margin-top: 50px;
`

export const ComponentsPage = () => (
  <div className="App" style={{ padding: 200 }}>
    <Row><Button>Cool button!</Button></Row>
    <Row><ButtonSecondary>Cool secondary button!</ButtonSecondary></Row>
    <Row><ButtonSmall>Smaller button!</ButtonSmall></Row>
    <Row><ButtonSecondarySmall>Smaller secondary button!</ButtonSecondarySmall></Row>

    <Row>
      <WithLabel label="First name of child">
        {id => <Input id={id} placeholder="Enter first name" />}
      </WithLabel>
    </Row>

    <Row>
      <WithLabel label="Select country">
        {id => <Select id={id}>
          <option>Select</option>
          <option>Afghanistan</option>
          <option>Albania</option>
          <option>Algeria</option>
          <option>Andorra</option>
        </Select>}
      </WithLabel>
    </Row>

    <Row>
      <Label>Gender</Label>
      <RadioButton id="1" name="myradios" label="Male" />
      <RadioButton id="2" name="myradios" label="Female" />
    </Row>

    <Row>
      <Label>What fruit do you like?</Label>
      <Checkbox id="3" label="Apples" />
      <Checkbox id="4" label="Banans" />
      <Checkbox id="5" label="Mangos" />
    </Row>

    <Row>
      <Label>Please click below to show how well your child handled that experience</Label>
      <Scale from={1} to={10} value={6} fromLabel="Very poorly" toLabel="Very well"
        // tslint:disable-next-line:jsx-no-lambda no-console
        onChange={val => console.log('clicked', val)} />
    </Row>

    <Row>
      <Label>I feel secure</Label>
      <Scale from={1} to={4} value={1} />
    </Row>

    <Row>
      <Link to="/">Normal link</Link>
      <LinkButton>Normal link</LinkButton>
    </Row>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/ComponentsPage.tsx